<template>
    <input type="text" class="form-control" role="presentation" :value="selected" @input="selectDate($event.target.value)"/>
</template>
<script>
import AirDatepicker from 'air-datepicker';
import deLang from 'air-datepicker/locale/de';

export default {
    name: 'Datepicker',
    props: {
        value: {
            type: [String, Date],
            default: '',
        },
        options: {
            type: Object,
            default: () => ({}),
        }
    },
    data: () => ({
        airpicker: null,
        selected: null,
    }),
    mounted() {
       this.airpicker = new AirDatepicker(this.$el, {
           ...this.options,
           locale: deLang,
           onSelect: ({formattedDate}) => {
               this.selected = formattedDate
           }
       });
       if (this.value) { this.selectDate(this.value); }
    },
    watch: {
        selected: function (date) {
            this.$emit('input', date);
        },
        value: function (date) {
            if (this.selected !== date && date !== '') {
                this.airpicker.selectDate(date);
            }
        },
        options: function (options) {
            this.airpicker.destroy();
            this.airpicker = new AirDatepicker(this.$el, {
                ...options,
                locale: deLang,
                onSelect: ({formattedDate}) => {
                    this.selected = formattedDate
                }
            });
            if (this.value) { this.selectDate(this.value); }
        }
    },
    methods: {
      selectDate(date) {
          if (date === '') {
              this.airpicker.clear();
              this.$emit('input', date);
              return;
          }
          if (typeof date === "string") {
            const parts = date.split('.');
            if (parts.length !== 3 || parts[2].length !== 4) return;
            date = new Date(parseInt(parts[2]), parseInt(parts[1])-1, parseInt(parts[0]));
          }
          this.airpicker.selectDate(date)
          this.airpicker.setViewDate(date)
          this.airpicker.setCurrentView('days')
      }
    },
    destroyed() {
        this.airpicker.destroy();
    }
}


</script>
